import { sharedDefaultConfigs } from '@pulse/browser-shared';
import { TrackerConfigurations } from '@pulse/common';

export const trackerConfigs: Required<TrackerConfigurations> = {
    ...sharedDefaultConfigs,

    sessionTimeoutMS: 1800000,
    attributeTimeoutMS: 86400000 * 7,
    attributeSyncIntervalMS: 86400000,
    plugins: [],
    transformPipes: [],
    enrichmentPipes: [],
    consentChecks: [],
    serverCookies: true,

    sessionStorageType: 'persistent',
    attributesStorageType: 'persistent',
    tabManagerStorageType: 'tab',
    debug: [],
    debugClear: false,
    debugLiveEventKey: 'debug-leuid',

    customerID: '',

    //
    // Queue  ------------------------------
    // -------------------------------------
    batchTimeMS: 500,
    batchSize: 100,

    //
    // HTTP --------------------------------
    // -------------------------------------
    serverBaseURL: 'https://t.picsart.com/events/v2/web',

    //
    // TRACK / ENRICH ----------------------
    // -------------------------------------
    stateEnrichment: true,
    attributeHints: true,

    //
    // STORAGE -----------------------------
    // -------------------------------------

    storagePrefix: 'paa_',
    tabOpenerDetectionTimeWindow: 6000,

    //
    // RUM -----------------------------
    // -------------------------------------
    rumUnsafeRequestBodyMeasure: false,
    rumReportOnce: [],
    rumReport: [],

    //
    // DataLayer -----------------------------
    // -------------------------------------
    dataLayerKey: 'dataLayer',
};
